import { Button, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import Trans from "@/components/Trans/Trans";

import { ErrorSectionVariants, IErrorCardProps, IErrorSectionProps } from "./types";

const errorSectionWrapperStyles = {
  shouldCenter: " w-full grow flex justify-center items-center",
  default: "w-full h-full",
};

const getErrorContent = (variant: ErrorSectionVariants) => {
  if (variant === ErrorSectionVariants.SOMETHING_WENT_WRONG) {
    return {
      title: <Trans i18nKey="error:title.somethingWentWrong" />,
      description: <Trans i18nKey="error:description.refreshOrTryLater" />,
      buttonText: <Trans i18nKey="error:cta.tryAgain" />,
    };
  }
  return null;
};

const ErrorCard = ({ title, description, buttonText, onClick }: IErrorCardProps) => {
  return (
    <div className="flex flex-col gap-[20px] items-center ">
      <div className="flex flex-col justify-center items-center">
        <Text variant={TextVariants.HEADING_6_BOLD}>{title}</Text>
        <Text variant={TextVariants.LABEL_LARGE_REGULAR}>{description}</Text>
      </div>
      <Button variant={ButtonVariant.CONTAINED} onClick={onClick} aria-label="action">
        {buttonText}
      </Button>
    </div>
  );
};

const ErrorSection = ({
  variant,
  onClick = () => {
    window.location.reload();
  },
  shouldCenter = false,
}: IErrorSectionProps) => {
  const contentVariant = variant || ErrorSectionVariants.SOMETHING_WENT_WRONG;
  const { title = "", description = "", buttonText = "" } = getErrorContent(contentVariant) || {};

  const containerStyle = shouldCenter ? errorSectionWrapperStyles?.shouldCenter : errorSectionWrapperStyles?.default;

  return (
    <div className={containerStyle}>
      <ErrorCard title={title} description={description} buttonText={buttonText} onClick={onClick} />
    </div>
  );
};

export default ErrorSection;
